import { createEnumSchemaPreprocessor } from '../../../utils/create-enum-schema-preprocessor';
import { z } from 'zod/v4';

export const routingTypeOptions = ['Practical', 'Shortest', 'Fastest'] as const;

export const routingTypeSchema = createEnumSchemaPreprocessor(
  z.enum(routingTypeOptions),
  routingTypeOptions
);

export type RoutingType = z.infer<typeof routingTypeSchema>;
